import React, { useEffect } from 'react';
import { Routes, Route, Navigate, useLocation, useParams } from 'react-router-dom';
import IndexFive from './index/index-five';
import IndexV2 from './index/index-v2';
import PrivacyPolicy from './components/privacy-policy';
import TermsOfService from './components/terms-of-service';
import AccountDeletion from './components/account-deletion';
import Permissions from './components/permissions';
import Support from './components/support';
import Licenses from './components/licenses';
import NotFound from './components/not-found';
import ResetPassword from './components/reset-password';
import CuzBasari from './pages/CuzBasari';
import AdminLogin from './pages/AdminLogin';
import AdminPanel from './pages/AdminPanel';
import AdminGroupDetail from './pages/AdminGroupDetail';
import Egitim from './components/egitim';
import { bolumeKaydir } from './lib/kaydir';

// Eski /cuzal/:hatimId linkleri: ana sayfadaki Cüz Al panelinde o grup seçili açılır
function CuzDetailRedirect() {
  const { hatimId } = useParams();
  return <Navigate to={{ pathname: '/', search: `?grup=${hatimId}`, hash: '#cuz-al' }} replace />;
}

// Sayfa değişince en üste, #bölüm varsa o bölüme kaydırır.
// Telefonda sayfayı body kaydırdığı için window.scrollTo tek başına yetmiyor.
function ScrollToHashElement() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) {
      // Bölüm yeni sayfayla birlikte çiziliyor olabilir
      const t = setTimeout(() => bolumeKaydir(hash.substring(1)), 50);
      return () => clearTimeout(t);
    }
    window.scrollTo(0, 0);
    document.body.scrollTop = 0;
  }, [pathname, hash]);

  return null;
}

function App() {
  return (
    <>
      <ScrollToHashElement />
      <Routes>
        <Route path='/' element={<IndexV2/>}/>
        <Route path='/old' element={<IndexFive/>}/>
        {/* Section redirects - these will redirect to home with hash */}
        <Route path='/features' element={<Navigate to="/" replace />} />
        <Route path='/screenshot' element={<Navigate to="/#screenshot" replace />} />
        <Route path='/faqs' element={<Navigate to="/#faqs" replace />} />
        <Route path='/download' element={<Navigate to="/#download" replace />} />
        <Route path='/contact' element={<Navigate to="/#contact" replace />} />
        
        {/* Cüz Al: seçim ve onay ana sayfada; eski adresler oraya yönlenir */}
        <Route path='/cuzal' element={<Navigate to="/#cuz-al" replace />} />
        <Route path='/cuzal/:hatimId' element={<CuzDetailRedirect/>}/>
        <Route path='/cuzal/:hatimId/basari' element={<CuzBasari/>}/>
        
        {/* Existing routes */}
        <Route path='/privacy-policy' element={<PrivacyPolicy/>}/>
        <Route path='/gizlilik-politikasi' element={<Navigate to="/privacy-policy" replace />} />
        <Route path='/terms-of-service' element={<TermsOfService/>}/>
        <Route path='/terms' element={<Navigate to="/terms-of-service" replace />} />
        <Route path='/kullanim-sartlari' element={<Navigate to="/terms-of-service" replace />} />
        <Route path='/account-deletion' element={<AccountDeletion/>}/>
        <Route path='/hesap-silme' element={<Navigate to="/account-deletion" replace />} />
        <Route path='/permissions' element={<Permissions/>}/>
        <Route path='/izinler' element={<Navigate to="/permissions" replace />} />
        <Route path='/support' element={<Support/>}/>
        <Route path='/destek' element={<Navigate to="/support" replace />} />
        <Route path='/licenses' element={<Licenses/>}/>
        <Route path='/lisanslar' element={<Navigate to="/licenses" replace />} />
        <Route path='/egitim' element={<Egitim/>}/>
        <Route path='/education' element={<Navigate to="/egitim" replace />} />
        <Route path='/reset-password' element={<ResetPassword/>}/>
        <Route path='/sifre-sifirla' element={<Navigate to="/reset-password" replace />} />
        
        {/* Admin Routes */}
        <Route path='/admin/login' element={<AdminLogin/>}/>
        <Route path='/admin/panel' element={<AdminPanel/>}/>
        <Route path='/admin' element={<AdminPanel/>}/>
        <Route path='/admin/group/:groupId' element={<AdminGroupDetail/>}/>
        
        <Route path='*' element={<NotFound/>}/>
      </Routes>
    </>
  );
}

export default App;
